<template>
  <el-dialog
      :visible.sync="visible"
      :title="title || 'Excel导入'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :width="dialogWidth"
  >
    <div class="up-box">
      <div class="place-holder">
        {{ placeHolder || '导入时请参照EXCEL模板格式进行导入' }}
      </div>
      <div class="btn-tmplate" v-if="templateUrl">
        <a :href="templateUrl" target="_blank">模板下载</a>
      </div>
    </div>
    <div class="btn-box">
      <slot></slot>
      <el-upload
          :action="uploadConfig.url"
          :before-upload="beforeUpload"
          :on-success="successHandle"
          :show-file-list="false"
          :on-error="errorHandle"
          :data="data"
      >

        <el-button type="warning" size="mini" icon="el-icon-upload">
          EXCEL导入
        </el-button>
      </el-upload>
    </div>
    <SweetTable v-if="tipType===2&&dataList&&dataList.length>0" :data="dataList" :height="500" :is-page="false">
      <el-table-column
          label="错误提示"
          header-align="center"
          align="center"
          prop="remark"
      >
      </el-table-column>
    </SweetTable>
  </el-dialog>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  props: {
    tipType: {
      type: Number,
      default: 1
    },
    config: {
      type: Object,
      default: () => {
        return {}
      },
    },
    templateUrl: {
      type: String,
      default: '',
    },
    uploadUrl: {
      type: String,
      default: '',
    },
    placeHolder: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    version: {
      type: String,
      default: 'v1'
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    data: {
      handler: function (newVal) {
        console.log('data', newVal)
      },
      immediate: true,
      deep: true
    },
    uploadUrl: {
      handler: function (newVal) {
        if (!newVal) {
          return
        }
        let baseUrl = window.SITE_CONFIG['apiURL']
        if (this.version !== 'v1') {
          baseUrl = window.SITE_CONFIG['api2URL']
        }
        this.uploadConfig.url = `${baseUrl}${newVal}?token=${Cookies.get('token')}`
      },
      immediate: true,
    },
  },
  computed: {
    dialogWidth () {
      if (this.tipType === 1) {
        return '500px'
      } else if (this.tipType === 2) {
        return '900px'
      }
    }
  },
  data () {
    return {
      id: '',
      visible: false,
      dataForm: {},
      dataList: [],
      uploading: false,
      uploadConfig: {
        url: '',
        maxSize: 100,
      },
    }
  },
  methods: {
    init () {
      this.visible = true
    },
    beforeUpload (file) {
      let ext = file.name.substr(file.name.indexOf('.'))
      let whiteList = ['xlsx', 'xls']
      let isWhite = whiteList.filter((item) => item === ext)
      const isLimit = file.size / 1024 / 1024 < this.uploadConfig.maxSize

      if (!isWhite) {
        this.$message.error('上传文件格式错误')
      }
      if (!isLimit) {
        this.$message.error(`文件大小不能超过 ${this.uploadConfig.maxSize}MB!`)
      }
      const isContinue = isWhite && isLimit
      if (isContinue) {
        this.uploadConfig.uploading = true
        this.loading = this.$loading()
      }
      return isContinue
    },
    successHandle (res, file, fileList) {
      this.uploadConfig.uploading = false
      this.loading.close()
      this.$notify.closeAll()
      if (res.code === 0) {
        this.$message.success('导入成功')
        this.$emit('success', res.data)
        this.visible = false
      } else if (res.code === 203) {
        this.$notify.closeAll()
        if (!res.msg) {
          return
        }
        let msgList = res.msg.split(';')
        if (this.tipType === 1) {

          msgList.forEach((m, index) => {
            if (!m) {
              return
            }
            setTimeout(() => {
              this.$notify({
                title: '错误提示',
                message: m,
                duration: 10000,
                dangerouslyUseHTMLString: true,
              })
            }, index * 100)
          })
        } else if (this.tipType === 2) {
          this.dataList = []
          msgList.forEach(r => {
            this.dataList.push({ remark: r })
          })
        }
        return
      } else {
        return this.$message.error(res.msg)
      }
    },
    errorHandle (err, file, fileList) {
      this.loading.close()
      this.uploadConfig.uploading = false
      this.$message.error('上传失败')
    },
  },
}
</script>

<style lang="scss" scoped>
.up-box {
  display: flex;
  flex-direction: column;
  padding: 10px 30px;

  .btn-tmplate {
    font-size: 16px;
    color: #409eff;
    padding-top: 10px;

    a {
      color: #409eff;
    }

    a:hover {
      color: #409eff;
    }
  }
}

.place-holder {
  color: #f56c6c;
  line-height: 150%;
  font-weight: 500;
  font-size: 16px;
}

.place-holder:before {
  content: "*";
}

.btn-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
